import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'

export default class QmlComponent extends React.Component {
    static cardName = `Common/SubPatientSmoke.qml`;
    
    constructor() {
        super()
        this._ismounted = false
        this.state = {
            qml : null
        }
    }

    componentDidMount() {
        this._ismounted = true
        //console.log("!!!<<<<<<CDM>>>>>>>!!! ", this.cardName)
        

        //console.log('about to this.loadQML')
// Soure code from QML file starts here 
setTimeout( () => { 
this.loadQML(String.raw`
import Semantic.Html 1.0
import QmlWeb 1.0
import '../DPO' as DPO

Form {
    id: root
    property var patientId
    property var canEdit: false
    property var formCode: 'CardPatientAssessment'
    property var formVersion: '0.1'
    property var UD:''
    property var drink:Object(
        {
            'NA': 'NA',
            'NO': 'ไม่ดื่ม',
            'YES': 'ดื่ม',
            'Past': 'มีประวัติการดื่ม'
        }
    )
    property var smoke:Object(
        {
            'NA': 'NA',
            'NO': 'ไม่สูบ',
            'YES': 'สูบ',
            'Past': 'มีประวัติการสูบ'
        }
    )
    function clear(){
        txtSmoking.text = ''
        txtDrinking.text = ''
        txtWeight.text = ''
        txtHeight.text = ''
    }
    function refresh(){
        clear()
        if (!root.patientId) return;
        refreshForm()
        refreshVS()
        refreshUD()
    }
    function refreshForm(){
        rmdSmokeDrink.query = {
            patient: root.patientId,
            form_code: root.formCode,
            form_version: root.formVersion,    
        }
        rmdSmokeDrink.fetch()
    }
    function refreshVS(){
        rmdVitalSign.query = {
            patient: root.patientId,
            all_latest_measurement: true,
        }
        rmdVitalSign.fetch()
    }
    function refreshUD(){
        rmdProblemListList.query = {}
        rmdProblemListList.query.patient = root.patientId
        rmdProblemListList.query.is_active = true
        rmdProblemListList.fetch()
    }
    Fields{
        RestModel{
            id: rmdProblemListList
            url:'/apis/DPO/problem-list/'
            property var items
            onFetched:{
                var text = ''
                items.forEach(function(object){
                    text += object.message + ', '
                })
                txtUD.text = text
            }
        }
        Field {
            label: "Underlying Disease"
            className:'sixteen wide'
            TextArea {
                id: txtUD
                placeholder: "Underlying Disease"
                rows: 2
                readOnly: true
            }
            Button {
                id: _btnUD
                enabled: root.patientId
                className: 'mini circular icon toggle active'
                style: 'position: absolute; right: 0px; margin-top: 2px;'
                Icon {
                    className: 'search'
                }
                onClicked: {
                    ldrPatientUD.loadAndShowModal()
                }
            }
            Loader{
                id: ldrPatientUD
                Modal{
                    id: modPatientUD
                    onShowed:{
                        crdPatientUD.refresh()
                    }
                    DPO.CardPatientUD{
                        id: crdPatientUD
                        patientId: root.patientId
                        underlying: root.UD
                        canEdit: true
                        hideHeaderIcon: true
                        toggleCard: false
                    }
                    onHidden:{
                        refreshUD()
                        ldrPatientUD.active = false
                    }
                }
            }
        }
    }
    Fields {
        RestModel{
            id: rmdVitalSign
            url: '/apis/PTM/vital-sign-value/'
            property var items
            onFetched:{
                items.forEach(function(object){
                    if(object.name == 'น้ำหนัก'){
                        txtWeight.text = object.result + ' ' + object.unit
                    }
                    else if(object.name == 'ส่วนสูง'){
                        txtHeight.text = object.result + ' ' + object.unit
                    }
                })
            }
        }
        Field {
            className: "eight wide"
            label: "น้ำหนัก"
            TextBox {
                id: txtWeight
                readOnly: true
                textLength: "10"
            }
        }
        Field {
            className: "eight wide"
            label: "ส่วนสูง"
            TextBox {
                id: txtHeight
                readOnly: true
                textLength: "10"
            }
        }
    }
    Fields {
        RestModel{
            id: rmdSmokeDrink
            url: '/apis/PTM/form-data-latest/'
            property var data
            onFetched:{
                txtSmoking.text = root.smoke[data.tobacco] + data.tobacco_specific
                txtDrinking.text = root.drink[data.alcohol] + data.alcohol_specific
            }
        }
        Field {
            className: "eight wide"
            label: "สูบบุหรี่"
            TextBox {
                id: txtSmoking
                textLength: "10"
                readOnly: true
            }
        }
        Field {
            className: "eight wide"
            label: "ดื่มสุรา"
            TextBox {
                id: txtDrinking
                textLength: "10"
                readOnly: true
            }
        }
    }
}
        `)
}, 0)

    }

    componentWillUnmount() {
        this._ismounted = false
        //console.log(" ***** componentWillUnmount ", this.cardName)
        document.onkeypress = null;
        document.onkeyup = null;

        // this.engine.stop()
        if(this.qml){
            this.qml.destroy()
            this.removeChildProperties(this.qml)
        }
        
        // this.qml = null
        // this.engine = null
        if(this.props.onUnmount){
            this.props.onUnmount()
         }
        // window.QmlWeb.engine.dom = null
        // window.QmlWeb.engine.domTarget = null
        // window.QmlWeb.engine.rootObject = null
        // window.QmlWeb.engine.completedSignals = []
        // window.QmlWeb.engine = {}
        //console.log(" ***** componentWillUnmount Finish ", this.cardName)
    }

    loadQML = (src, parentComponent = null, file = undefined) => {
        this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        
        // let component = this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        // this.qml = this.engine.rootObject
        // return component
    }

    loadQMLTree = (tree, parentComponent = null, file = undefined) => {

        // Part 1
        let QMLComponent; 
        let component;

        setTimeout( () => { 

            if (!this._ismounted){
                //console.log(" Shutdown Part 1", this.cardName)
                return;
            }
            this.engine = window.QmlWeb.engine;
        
            if (!this.engine) {
                this.engine = new window.QmlWeb.QMLEngine(ReactDOM.findDOMNode(this));
                // window.addEventListener("resize", () => this.engine.updateGeometry());
            } else {
                this.engine.cleanEngine(ReactDOM.findDOMNode(this))
            }

            this.engine.$basePathA = document.createElement('a')
            this.engine.$basePathA.href = this.extractBasePath(`/static/qml/Common/SubPatientSmoke.qml`)
            this.engine.$basePath = this.engine.$basePathA.href
            //console.log(" CDM this.engine.$basePathA.href: ", this.engine.$basePathA.href)

            window.QmlWeb.engine = this.engine;

            // Create and initialize objects
            QMLComponent = window.QmlWeb.getConstructor("QtQml", "2.0", "Component");
            component = new QMLComponent({
                object: tree,
                parent: parentComponent
            });
            //console.log("Part 1", this.cardName)
        },0)

        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 2", this.cardName)
                return;
            }
            
            this.engine.loadImports(tree.$imports, undefined, component.importContextId);
            component.$basePath = this.engine.$basePath;
            component.$imports = tree.$imports; // for later use
            component.$file = file; // just for debugging
            //console.log("Part 2", this.cardName)
        }, 0);
    

        // Part 3,4,5
        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 3", this.cardName)
                return;
            }
            this.engine.rootObject = component.$createObject(parentComponent);
            
            if (this.engine.rootObject.dom) {
                this.engine.domTarget.appendChild(this.engine.rootObject.dom);
            }
     
            this.qml = this.engine.rootObject
            this.setUpSignals()
            this.setUpProperties()
            //console.log("3. setUpSignals(), setUpProperties() Done", this.cardName)
 
            this.engine.$initializePropertyBindings();
            this.engine.start();

            this.engine.updateGeometry();
            this.qml = this.engine.rootObject

            this.setState({qml: this.qml})
            //console.log("4. finish loadQMLTree", this.cardName)

            
            this.engine.firstCallCompleted = false;
            this.engine.callCompletedSignals();
            this.engine.firstCallCompleted = true;
            //console.log("5. CallCompletedSignal", this.cardName)

            if (this.props.completedQMLLoad) {
                //console.log("Callback completedQMLLoad !!")
                setTimeout( () => {
                    this.props.completedQMLLoad()
                })
            }
        }, 0);
    }
    
    deCapitalizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    hasSignalName(signalName) {
        return (
            typeof this.qml[signalName] === 'function' 
            && typeof this.qml[signalName].connect === 'function'
        )
    }

    setUpSignals() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let startsWithOn = key.startsWith('on')
            let typeFunction = typeof value === 'function'
            if (!startsWithOn || !typeFunction) {
                return
            }
            if (!this.hasSignalName(signalName)) {
                console.warn('Cannot find a signal name: ' + signalName)
                return
            }
            this.qml[signalName].disconnect()
            this.qml[signalName].connect(this.qml, value)
        })
    }

    setUpProperties() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let propertyExists = typeof this.qml.$properties[key] !== 'undefined'
            if (this.hasSignalName(signalName)) {
                return
            }
            if (!propertyExists) {
                const createProperty = window.QmlWeb.createProperty;
                createProperty("variant", this.qml, key, value);
                //console.warn('Cannot find a property name: ' + key)
                // return
            }
            this.qml[key] = value
        })
    }

    extractBasePath(file) {
        const basePath = file.split(/[/\\\\]/)
        basePath[basePath.length - 1] = ''
        return basePath.join('/')
    }

    extractFileName(file) {
        return file.split(/[/\\\\]/).pop()
    }

    removeChildProperties(child) {
        const signals = this.engine.completedSignals
        if (signals) {
            signals.splice(signals.indexOf(child.Component.completed), 1)
        }
        if(child.children) {
            for (let i = 0; i < child.children.length; i++) {
                this.removeChildProperties(child.children[i])
            }
        }
        child.$signals = null
    }

    render() {
        if (this.state.qml) {
            this.setUpSignals()
            this.setUpProperties()
        }
        return React.createElement('div')
    }
}